// https://vuex.vuejs.org/en/actions.html

export default {
  setLogin({commit}) {
    commit('setLogin')
  },
  setLogout({commit}) {
    commit('setLogout')
  },
  getProvs({commit}) {
    commit('getProvs')
  },
  getRules({commit}) {
    commit('getRules')
  },
  setEditDialogState({commit},obj) {
    commit('setEditDialogState',obj)
  },
  setLoginInfo({commit},obj) {
    commit('setLoginInfo',obj)
  }
}
